module.exports = __webpack_public_path__ + "img/roterothopter_small.8ed46a9b.png";